import React, { useEffect } from 'react';
import { Box } from '@mui/system';
import { Divider, Typography, Checkbox, MenuItem } from '@mui/material';
import { FieldCurrencyComponentDigits } from '@giro/shared-components/Fields/FieldCurrency.component';
import FieldLabelFormikComponent from '@giro-pdv/components/FieldLabelFormik.component';
import TextFieldLabelComponent from '@giro-pdv/components/TextFieldLabel.component';
import tablePayment from '../store/tablePayment';
import { useSelector } from 'react-redux';
import amount from '../store/recharge/amount';
import NumberFormat from 'react-number-format';

const normalizeType = {
  LIC: 'Licenciamento',
};

const DistributionComponent = ({
  distributionPayload,
  onChange = (val) => {},
  ...restProps
}) => {
  const selectorRedux = {
    amount: useSelector(tablePayment.selector.selectAmount),
    return: useSelector(tablePayment.selector.selectReturn),
  };

  const [value, setValue] = React.useState<number>(0);
  const [amount, setAmount] = React.useState<number>(0);
  const [percentage, setPercentage] = React.useState<number>(0);

  const handleChange = (v: any) => {
    const val = v.target.value;
    const distribution = distributionPayload.find(
      (e) => e.CdClienteDistribuicao === val
    );
    setPercentage(distribution.PercentualDistribuicao);
    setValue(amount ? amount * percentage : 0);
    if (onChange) {
      onChange({ value, id: distribution.CdClienteDistribuicao });
    }
  };

  useEffect(() => {
    setValue(amount ? amount * percentage : 0);
  }, [amount, percentage]);

  useEffect(() => {
    setAmount((selectorRedux.amount * selectorRedux.return) / 100);
  }, [selectorRedux.amount, selectorRedux.return]);

  return (
    <Box display="grid" gridTemplateColumns="5fr 4fr" gap={4}>
      <FieldLabelFormikComponent
        name="distribution"
        label="Distribuição"
        select
        disabled={distributionPayload?.length === 0}
        size="small"
        onChange={(v) => handleChange(v)}
      >
        {distributionPayload?.map((od) => (
          <MenuItem
            value={od.CdClienteDistribuicao}
            key={od.CdClienteDistribuicao}
          >
            {od?.ClienteDistribuicao?.Nome} - {od?.PercentualDistribuicao}%
          </MenuItem>
        ))}
      </FieldLabelFormikComponent>
      <Box display="grid" gridTemplateRows="1fr 1fr">
        <Typography variant="trasso_body_medium" color="trasso.purple.100">
          Valor da Distribuição
        </Typography>
        <Box
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <NumberFormat
            suffix={'%'}
            prefix={''}
            isNumericString
            decimalScale={2}
            fullWidth
            disabled={true}
            displayType="text"
            value={percentage}
          />
          {` = `}
          <FieldCurrencyComponentDigits
            displayType="text"
            customInput={TextFieldLabelComponent}
            size="small"
            name="distribution_value"
            label="Valor de Distribuição"
            disabled={true}
            value={value}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default DistributionComponent;
